var _circle, _circle2, _circle3, _circle4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChooseservice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#003C8A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    fillOpacity: 0.95
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#003C8A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "white",
    strokeOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 13.3337H27.5V15.0003H16.6667V13.3337ZM13.75 15.417C13.4185 15.417 13.1005 15.2853 12.8661 15.0509C12.6317 14.8165 12.5 14.4985 12.5 14.167C12.5 13.8355 12.6317 13.5175 12.8661 13.2831C13.1005 13.0487 13.4185 12.917 13.75 12.917C14.0815 12.917 14.3995 13.0487 14.6339 13.2831C14.8683 13.5175 15 13.8355 15 14.167C15 14.4985 14.8683 14.8165 14.6339 15.0509C14.3995 15.2853 14.0815 15.417 13.75 15.417ZM13.75 21.2503C13.4185 21.2503 13.1005 21.1186 12.8661 20.8842C12.6317 20.6498 12.5 20.3318 12.5 20.0003C12.5 19.6688 12.6317 19.3509 12.8661 19.1164C13.1005 18.882 13.4185 18.7503 13.75 18.7503C14.0815 18.7503 14.3995 18.882 14.6339 19.1164C14.8683 19.3509 15 19.6688 15 20.0003C15 20.3318 14.8683 20.6498 14.6339 20.8842C14.3995 21.1186 14.0815 21.2503 13.75 21.2503ZM13.75 27.0003C13.4185 27.0003 13.1005 26.8686 12.8661 26.6342C12.6317 26.3998 12.5 26.0818 12.5 25.7503C12.5 25.4188 12.6317 25.1009 12.8661 24.8664C13.1005 24.632 13.4185 24.5003 13.75 24.5003C14.0815 24.5003 14.3995 24.632 14.6339 24.8664C14.8683 25.1009 15 25.4188 15 25.7503C15 26.0818 14.8683 26.3998 14.6339 26.6342C14.3995 26.8686 14.0815 27.0003 13.75 27.0003ZM16.6667 19.167H27.5V20.8337H16.6667V19.167ZM16.6667 25.0003H27.5V26.667H16.6667V25.0003Z",
    fill: "#003C8A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseservice);
export default __webpack_public_path__ + "static/media/chooseservice.07c8e8d30d47bb1a9674b37b2e070917.svg";
export { ForwardRef as ReactComponent };